export default __webpack_public_path__ + "static/media/image-board-study-now-n-w.0959af26.webp";